// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConfigurationAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { EMAIL_VALIDATION } from 'logic/data/Izenda.EmailConstants';
import { get, isEmpty } from 'lodash/fp';

export default withHandlers({
  /**
   * Enable System configuration
   */
  enableSystemConfig: props => () => {
    props.store.clonedEmailConfiguration.setValueByKey('useSystemConfiguration', true);
  },

  /**
   * Enable Custom configuration
   */
  enableCustomConfig: props => () => {
    props.store.clonedEmailConfiguration.setValueByKey('useSystemConfiguration', false);
  },

  /**
   * Cancel Change config
   */
  cancelChangeConfig: props => () => {
    const { validation: valManager, localization, store } = props;
    const { clonedEmailConfiguration: emailConfiguration, alertDetails } = store;

    valManager.reset();

    if (!emailConfiguration.isDirty) {
      showNoChangesFound(alertDetails, localization);
    } else {
      return props.confirmFn('Confirmation', {
        description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
      }).then(() => {
        store.cancelChangeConfiguration();
        emailConfiguration.resetDirty();
        alertDetails.reset();
      });
    }
  },

  /**
   * Save email config
   */
  saveConfig: props => () => {
    const { validation: valManager, localization, store, loader } = props;
    const { clonedEmailConfiguration: emailConfiguration, alertDetails } = store;

    if (!emailConfiguration.isDirty) {
      showNoChangesFound(alertDetails, localization);
    } else {
      valManager.validate().then(success => {
        if (success && validateEmailAddress(props)) {
          return props
            .confirmFn('Confirmation', {
              description: localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
            })
            .then(function() {
              loader.startLoading();
              return store.saveEmailConfiguration();
            })
            .then(function(result) {
              var messages = result.messages || {};
              messages.length && (messages = messages[0].messages && messages[0].messages[0]);
              messages = result.success ? localization.getText('COMMON_MESSAGES_DETAILS_WERE_SAVED') : messages;
              store.alertDetails.set({
                success: result.success,
                message: messages
              });
            })
            .finally(loader.endLoading.bind(loader));
        }
      });
    }
  },

  /**
   * Reset alert details
   */
  resetAlert: props => () => {
    return props.store.alertDetails.reset();
  }
});

function showNoChangesFound(alertDetails: any, localization: any) {
  alertDetails.set({
    success: true,
    message: localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND')
  });
}

function validateEmailAddress(props: any) {
  const { validation: valManager } = props;
  const email = get('store.clonedEmailConfiguration.emailFromAddress', props);
  var messages = [];
  if (email && !EMAIL_VALIDATION.REGEX.test(email)) {
    messages.push({
      key: 'emailFromAddress',
      messages: [EMAIL_VALIDATION.MESSAGE([email])]
    });
  }
  !isEmpty(messages) && valManager.updateErrors(messages);
  return isEmpty(messages);
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Email/Izenda.EmailConfigurationAction.js